export type ReviewDimensionKey =
  | "deliveredAsDescribed"
  | "communication"
  | "boundaries"
  | "valueForMoney"
  | "audienceConduct";

export interface ReviewDimensionDefinition {
  key: ReviewDimensionKey;
  label: string;
  guidance?: string;
  options?: { value: number; label: string }[];
}

export const REVIEW_DIMENSIONS: ReviewDimensionDefinition[] = [
  { key: "deliveredAsDescribed", label: "Delivered as described" },
  {
    key: "communication",
    label: "Communication and responsiveness",
  },
  {
    key: "boundaries",
    label: "Boundaries and professionalism",
  },
  { key: "valueForMoney", label: "Value for money" },
  {
    key: "audienceConduct",
    label: "Audience / community conduct",
    guidance:
      "Rate only audience behaviour you personally observed—such as respect, harassment, pressure, dogpiling, or boundary-crossing. Do not rate beliefs, identities, or ordinary disagreement. This score describes the audience, not the practitioner.",
    options: [
      { value: 1, label: "1 — consistently hostile or harassing" },
      { value: 2, label: "2 — often disrespectful" },
      { value: 3, label: "3 — mixed or unclear" },
      { value: 4, label: "4 — generally respectful" },
      { value: 5, label: "5 — consistently respectful and constructive" },
    ],
  },
];
